import { useQuery } from "react-query";
import axiosClient from "../../lib/axios";
import { IDataPesquisarTiposCafe } from "../../types/api/cafe/pesquisar-tipos-cafe";
import { Autocomplete, Checkbox, FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, TextField } from "@mui/material";
import { onChangeMultipleValue } from "./helpers";

export default function SelectTipoCafe({
    value,
    onChange,
    type = "single"
}: SelectSimpleApiQueryProps) {

    //queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: ["pesquisar-tipos-cafe"],
        queryFn: () => axiosClient.get("pesquisar-tipos-cafe", {
            params: {
                limit: 50
            }
        })
    });
    const listData: IDataPesquisarTiposCafe[] = data?.data.data || []
    //

    if (type === "single") return (
        <Autocomplete
            disablePortal
            disabled={isLoading}
            id="combo-box-demo"
            value={value as SingleValue}
            fullWidth
            options={listData.map((i) => ({ label: i.tipo_nome, id: i.tipo_id }))}
            onChange={(_: any, newValue: TObjValue | null) => {
                onChange(newValue);
            }}
            renderInput={(params) => <TextField {...params} label={isLoading ? "Carregando" : "Tipo"} />}
        />
    )

    //type == multiple
    const valorFormatado = (value as TObjValue[]).map((item) => `${item.id},${item.label}`)

    const handleChangeMultipleValue = (event: SelectChangeEvent<string[]>) => {
        const valorFinal = onChangeMultipleValue(event.target.value as string[])
        onChange(valorFinal as MultipleValue)
    }
    //

    return (
        <FormControl fullWidth>
            <InputLabel id="tipo-cafe">{isLoading ? "Carregando" : "Tipo"}</InputLabel>
            <Select
                labelId="tipo-cafe"
                id="demo-multiple-name"
                multiple
                disabled={isLoading}
                value={valorFormatado}
                onChange={handleChangeMultipleValue}
                input={<OutlinedInput label="Tipo" />}
                renderValue={(selected) => selected.map(e => e.split(",")[1]).join(', ')}
            >
                <MenuItem value="NaN,Todos(as)">
                    <Checkbox checked={valorFormatado.indexOf("NaN,Todos(as)") > -1} />
                    Todos(as)
                </MenuItem>

                {[...listData].map((item) => {
                    const valorOption = `${item.tipo_id},${item.tipo_nome}`
                    return (
                        <MenuItem
                            key={item.tipo_id}
                            value={valorOption}
                        >
                            <Checkbox checked={valorFormatado.indexOf(valorOption) > -1} />
                            {item.tipo_nome}
                        </MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
}

interface SelectSimpleApiQueryProps {
    type?: 'single' | 'multiple';
    value: SelectValue;
    onChange: (arg: SelectValue) => void;
}

type SelectValue = SingleValue | MultipleValue;

type SingleValue = TObjValue | null;
type MultipleValue = TObjValue[];

type TObjValue = { label: string, id: number }